import Vue from "vue";

const test_default = (value) => !!value;

/**
 * @param {object} form
 * @param {Criterion[]} criteria
 * @returns {boolean}
 */
function validate(form, criteria) {
    try {
        for (const { key, message, test = test_default } of criteria) {
            let keys = key.split(".");
            let data = keys.reduce((form, key) => form?.[key], form);

            if (!test(data)) throw new Error(message);
        }

        return true;
    } catch (error) {
        alert(error.message);
        return false;
    }
}

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function(Vue, options) {
    Vue.prototype.$validate = validate;
};

Vue.use({ install });

export default validate;

/**
 * @typedef {object} Criterion
 *
 * @property {string} key property key
 * @property {(value:string) => boolean} test
 * @property {string} message error message
 */
